import { enableReceiver } from './actions';
import { SIGNATURE_MESSAGE_NAME } from './constants';
import logger from './logger';
export function sendSignatureEndpointMessage(conference, to, event) {
    if (!to) {
        logger.warn('Signature: Skip sending Signature event. Params:', to);
        return false;
    }
    try {
        conference?.sendEndpointMessage(to, {
            name: SIGNATURE_MESSAGE_NAME,
            ...event
        });
        return true;
    }
    catch (error) {
        logger.error('Failed to send EndpointMessage via the datachannels', error);
        return false;
    }
}
export function onSignatureAPIEvent({ getState, dispatch }) {
    dispatch(enableReceiver());
}
// export function getConferenceState(stateful: IStateful) {
//     const state = toState(stateful);
//     const { conference } = state['features/base/conference'];
//     return conference;
// }
